import React from 'react'
// interface Props {
//   children: React.ReactNode
// }
const Redirect = () => {
  return (<div />)
}

export default Redirect
